//chapter1
export default {
    id : 4,//chapter number
    title : '04. 몰드 공정(Molding) (4)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/04/videos/a04.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '에폭시 몰딩 컴파운드',
                '파우더 에폭시 몰딩 컴파운드',
            ],
            body2 : [
                '에폭시 몰딩 컴파운드에 대해 설명할 수 있다.',
                '파우더 에폭시 몰딩 컴파운드에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/04/videos/04.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '트랜스퍼 몰딩에서는 기판의 크기가 커지면 불완전 몰딩이 발생할 가능성이 크다.',//html available
                    answer : "1",
                    explain : '트랜스퍼 몰딩에서는 기판의 크기가 커지면 불완전 몰딩이 발생할 가능성이 크다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '컴프레션 몰딩 방법은 칩이 여러 개 적층된 제품과 대면적 기판 제품에 유리하다.',//html available
                    answer : "1",
                    explain : '컴프레션 몰딩 방법은 칩이 여러 개 적층된 제품과 대면적 기판 제품에 유리하다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>에폭시 몰딩 컴파운드<br>
                        - 리드 프레임(PCB), 골드 와이어와 더불어 반도체 후 공정에 사용되는 3대 기능성 재료 중 하나<br>
                        - 외부의 열에 의해 3차원 경화구조를 형성하는 열경화성의 고분자소재<br>
                        - 재료의 기능강화를 위해 Filler를 섞은 무기/유기 복합소재<br>
                        - 성형 특성, 기계적 특성이 우수하고 가격이 저가인 에폭시 사용<br>
                        - Epoxy Molding Compound로 부름. 펠렛 형태로 공급</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>파우더 에폭시 몰딩 컴파운드<br>
                        - FFT(Flow free thin) mold용 EMC<br>
                        - Fine pitch와 long wire device를 위하여, compound flow & injection speed를 최소화 시킴<br>
                        - Low pressure molding이 가능함(Low-k die)<br>
                        - EMC 낭비가 없음(No cull block)</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/04/videos/a04.mp4',
        },
    ]
}